import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { UserIcon } from 'components/vectors';
import { getUserToken, logout } from 'libs/helpers';
import { Formik } from 'formik';
import Swal from 'sweetalert2'



const ProfileSettings = props => {
    const { history } = props
    console.log(getUserToken())
    const [profile, setProfile] = useState({id: '', full_name: '', email: '', organization: '', role_id: ''})

    useEffect(() => {
        fetch('https://musicandrights.herokuapp.com/api/v1/user/profile',{
            headers: {'Authorization': `Bearer ${getUserToken()}`}
        })
        .then(res =>  res.json())
        .then( res => {
            console.log(res)
            if(res.code === 200) {
                setProfile(res.data.user);
            }
        })
        .catch(err => console.log(err))
    }, []);
    return (
    <Fragment>
        <div className="d-flex flex-row ">
            <UserIcon />
            <p className="text--medium text--black ml-3">Profile</p>
        </div>
        <Formik
            enableReinitialize={true}
            initialValues={profile}
            validate={ values => {
                let errors = {}
                if (!values.full_name || values.full_name.length < 5) {
                    errors.full_name = true
                }
                if (!values.organization ){
                    errors.organization = true
                }
            }}
            onSubmit={(values, {isSubmitting, setSubmitting}) => {
                setSubmitting(true)
                fetch('https://musicandrights.herokuapp.com/api/v1/user/update_profile',{
                    method: 'PUT',
                    headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'},
                    body: JSON.stringify({full_name: values.full_name, organization: values.organization})
                })
                .then(res =>  res.json())
                .then( res => {
                    setSubmitting(false)
                    console.log(res)
                    if(res.code === 200) {  
                        //updated
                        Swal.fire({
                            type: 'info',
                            title: 'Profile Update',
                            text: res.data.message
                        })
                    }
                    if (res.code === 400){
                        Swal.fire({
                            type: 'error',
                            title: 'Profile Update',
                            text: res.data.message
                        })
                    }
                })
                .catch(err =>{
                    setSubmitting(false)
                    console.log(err)
                })

            }}>
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <div>
                                    <label className="nsForm-label">Full Name</label>
                                    <input
                                        type="text"
                                        className={`nsForm-input ${ touched.full_name && errors.full_name ? 'error': null}`} 
                                        placeholder="Adebola James"
                                        value={values.full_name}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div>
                                    <label className="nsForm-label">Email Address</label>
                                    <input
                                        type="email"
                                        className="nsForm-input"
                                        value={values.email}
                                        placeholder="adebolajames@yahoo.co.uk"
                                        disabled
                                        style={{cursor:'not-allowed'}}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div>
                                    <label className="nsForm-label">Organization</label>
                                    <input 
                                        type="text"
                                        name="organization"
                                        className={`nsForm-input ${ touched.organization && errors.organization ? 'error': null}`} 
                                        placeholder="Artist" 
                                        value={values.organization}
                                        onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="row profile-action__container">
                            <div className="col-md-4 ml-auto">
                                <button type="submit" className={`w-100 box box-xs ${isSubmitting ? 'box--secondary' : 'box--grey'} nsForm-btn`}>
                                    <p>{isSubmitting ? 'Saving ...': 'Save Changes'}</p>
                                    </button>
                            </div>
                            <div className="col-md-12 mt-4">
                                <div className="line--grey" />
                            </div>
                        </div>
                    </form>
                )}


        </Formik>
        

        <div className="mt-5 mb-4">
            <p className="text--medium text--black">Change Password</p>
        </div>

        <Formik
            initialValues={{old_password: '',new_password: '', confirm_new_password: ''}}
            validate={ values => {
                let errors = {}
                if (!values.old_password || values.old_password.length < 5) {
                    errors.old_password = true
                }
                if (!values.new_password || values.new_password.length < 5) {
                    errors.new_password = true
                }
                if (!values.confirm_new_password || values.confirm_new_password.length < 5 || values.confirm_new_password !== values.new_password ) {
                    errors.confirm_new_password = true
                }
                return errors;
            }}
            onSubmit={(values, {isSubmitting, setSubmitting}) => {
                setSubmitting(true)
                fetch('https://musicandrights.herokuapp.com/api/v1/user/change_password',{
                    method: 'PUT',
                    headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'},
                    body: JSON.stringify(values)
                })
                .then(res =>  res.json())
                .then( res => {
                    setSubmitting(false)
                    console.log(res)
                    if(res.code === 200) {  
                        //updated
                        Swal.fire({
                            type: 'info',
                            title: 'Profile Update',
                            text: res.data.message,
                            onOpen: () => {
                                setTimeout( () => {
                                    logout()
                                    history.push('/login')
                                }, 3000)
                            }
                        }).then((confirm) => {
                            if (confirm){
                                logout()
                                history.push('/login')
                            }
                        })
                    }
                    if (res.code === 400){
                        Swal.fire({
                            type: 'error',
                            title: 'Profile Update',
                            text: res.message
                        })
                    }
                })
                .catch(err =>{
                    setSubmitting(false);
                    console.log(err)
                    })

            }}>
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    /* and other goodies */
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6">
                                <div>
                                    <label className="nsForm-label">Old Password</label>
                                    <input name="old_password" type="password" className={`nsForm-input ${ touched.old_password && errors.old_password ? 'error': null}`}  placeholder=""  onChange={handleChange}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div>
                                    <label className="nsForm-label">New Password</label>
                                    <input name="new_password" type="password" className={`nsForm-input ${ touched.new_password && errors.new_password ? 'error': null}`}  placeholder="" onChange={handleChange}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div>
                                    <label className="nsForm-label">Confirm Password</label>
                                    <input name="confirm_new_password" type="password" className={`nsForm-input ${ touched.confirm_new_password &&  errors.confirm_new_password ? 'error': null}`}  placeholder="" onChange={handleChange}/>
                                </div>
                            </div>
                        </div>

                        <div className="row profile-action__container">
                            <div className="col-md-4 ml-auto">
                                <button type="submit" className={`w-100 box box-xs ${isSubmitting ? 'box--secondary' : 'box--grey'} nsForm-btn`} disabled={isSubmitting}>
                                    <p>{isSubmitting ? 'Saving ....': 'Save Changes'}</p>
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            
            </Formik>

        
    </Fragment>
)};

export default withRouter(ProfileSettings);
